import { render } from "./ApplicationSchool.vue?vue&type=template&id=98be078e"
import script from "./ApplicationSchool.vue?vue&type=script&lang=js"
export * from "./ApplicationSchool.vue?vue&type=script&lang=js"

import "./ApplicationSchool.vue?vue&type=style&index=0&id=98be078e&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__